import React from 'react';
import PropTypes from 'prop-types';
import styles from './3Group.module.css';
import BasePanel from '../BasePanel/BasePanel.jsx';

const threeGroupImg = require('../../../../images/Illustration_Classic_Group_of_3.png');
const threeGroupCanNotLoadImg = require('../../../../images/adshel_can_not_load_adcopy.png');

const ThreeGroup = ({ mediaArray, videoAutoPlayInterval }) => {
    return (
        <div className={styles.panelRow}>
            <BasePanel
                mediaArray={mediaArray}
                backgroundImage={threeGroupImg}
                cannotLoadImage={threeGroupCanNotLoadImg}
                customStyles={styles}
                numberOfFrames={3}
                autoPlayInterval={15000}
                videoAutoPlayInterval={videoAutoPlayInterval}
            />
        </div>
    );
};

ThreeGroup.propTypes = {
    mediaArray: PropTypes.arrayOf(PropTypes.shape({
        type: PropTypes.string.isRequired,
        src: PropTypes.string.isRequired,
        alt: PropTypes.string,
        height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        groupingKey: PropTypes.string.isRequired,
        groupingIndex: PropTypes.number.isRequired
    })).isRequired,
    videoAutoPlayInterval: PropTypes.number
};

export default React.memo(ThreeGroup);